function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M404.89,670.57H397a.68.68,0,0,1-.7-.7.37.37,0,0,1,.1-.3l1.3-2.6a.68.68,0,0,1,.6-.4h5.3a.62.62,0,0,1,.6.4l1.3,2.6a.69.69,0,0,1-.3.9A.37.37,0,0,1,404.89,670.57Zm-6.9-1.3h5.8l-.7-1.3h-4.5Z",
  transform: "translate(-394.89 -666.57)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M405.49,674.57h-9.2a.68.68,0,0,1-.7-.7v-2.6a.37.37,0,0,1,.1-.3l.7-1.3a.68.68,0,0,1,.6-.4h7.9a.62.62,0,0,1,.6.4l.7,1.3c0,.1.1.2.1.3v2.6A.85.85,0,0,1,405.49,674.57Zm-8.6-1.4h7.9v-1.8l-.4-.8h-7.1l-.4.8Z",
  transform: "translate(-394.89 -666.57)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M396.89,669.87h-1.3a.7.7,0,1,1,0-1.4h1.3a.7.7,0,1,1,0,1.4Z",
  transform: "translate(-394.89 -666.57)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M398.29,672.57h-2a.7.7,0,0,1,0-1.4h2a.68.68,0,0,1,.7.7A.84.84,0,0,1,398.29,672.57Z",
  transform: "translate(-394.89 -666.57)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M405.49,672.57h-2a.7.7,0,1,1,0-1.4h2a.7.7,0,0,1,0,1.4Z",
  transform: "translate(-394.89 -666.57)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M406.19,669.87h-1.3a.7.7,0,1,1,0-1.4h1.3a.68.68,0,0,1,.7.7A.84.84,0,0,1,406.19,669.87Z",
  transform: "translate(-394.89 -666.57)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M398.29,676.47h-2a.68.68,0,0,1-.7-.7v-2a.68.68,0,0,1,.7-.7h2a.68.68,0,0,1,.7.7v2A.84.84,0,0,1,398.29,676.47Zm-1.4-1.3h.7v-.7h-.7Z",
  transform: "translate(-394.89 -666.57)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M405.49,676.47h-2a.68.68,0,0,1-.7-.7v-2a.68.68,0,0,1,.7-.7h2a.68.68,0,0,1,.7.7v2A.68.68,0,0,1,405.49,676.47Zm-1.3-1.3h.7v-.7h-.7Z",
  transform: "translate(-394.89 -666.57)"
});

function SvgIconTcOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 9.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTcOff);
export default __webpack_public_path__ + "static/media/icon-tc-off.743ca536.svg";
export { ForwardRef as ReactComponent };